import "./skills.scss";
import { useReveal } from "../../hooks/useReveal";

const GROUPS = [
  {
    category: "AI / LLM Engineering",
    color: "#dc143c",
    skills: [
      { name: "Agentic Workflows & MCP", pct: 95 },
      { name: "RAG Pipelines & Vector DBs", pct: 90 },
      { name: "LLM Integration & Tool Use", pct: 92 },
      { name: "Prompt Engineering", pct: 88 },
    ],
  },
  {
    category: "Mobile & AR",
    color: "#8b5cf6",
    skills: [
      { name: "SwiftUI / iOS", pct: 95 },
      { name: "ARKit & RealityKit", pct: 90 },
      { name: "LiDAR & Spatial Computing", pct: 85 },
      { name: "Android / Kotlin", pct: 75 },
    ],
  },
  {
    category: "Full Stack & Platform",
    color: "#10b981",
    skills: [
      { name: "React / Angular", pct: 88 },
      { name: "Python / FastAPI", pct: 90 },
      { name: "Node.js & REST APIs", pct: 85 },
      { name: "Azure / AWS", pct: 78 },
    ],
  },
];

function SkillBar({ name, pct, color, visible, delay }) {
  return (
    <div className="skillBar">
      <div className="skillMeta">
        <span className="skillName">{name}</span>
        <span className="skillPct">{pct}%</span>
      </div>
      <div className="barTrack">
        <div
          className="barFill"
          style={{
            width: visible ? `${pct}%` : "0%",
            backgroundColor: color,
            transitionDelay: delay,
          }}
        />
      </div>
    </div>
  );
}

export default function Skills() {
  const [sectionRef, visible] = useReveal(0.08);

  return (
    <div className="skills" id="skills" ref={sectionRef}>
      <div className={`sk-header ${visible ? "visible" : ""}`}>
        <h1>Technical Skills</h1>
        <p className="sk-subtitle">
          8+ years of depth across AI engineering, mobile development, and
          platform engineering.
        </p>
      </div>
      <div className="skillsGrid">
        {GROUPS.map((group, gi) => (
          <div
            className={`skillGroup ${visible ? "visible" : ""}`}
            key={group.category}
            style={{ transitionDelay: visible ? `${gi * 0.15}s` : "0s" }}
          >
            <h3 style={{ color: group.color }}>{group.category}</h3>
            {group.skills.map((skill, si) => (
              <SkillBar
                key={skill.name}
                {...skill}
                color={group.color}
                visible={visible}
                delay={visible ? `${gi * 0.15 + si * 0.08 + 0.2}s` : "0s"}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
